module.exports = __webpack_public_path__ + "img/single-sided-decorative.ebe2034b.jpg";